import React from "react";
import Grid from "@mui/material/Grid";
import LoadingButton from "@mui/lab/LoadingButton";
import { useFetcher, useLoaderData } from "react-router-dom";

import { GetCampaignDetailsResponse } from "services/apiService";
import PhoneNumberInput from "components/PhoneNumberInput";
import { ToastContainer } from "react-toastify";

const SendTest = () => {
    const campaign = useLoaderData() as GetCampaignDetailsResponse;

    const fetcher = useFetcher();

    return (
        <Grid
            container
            display="flex"
            justifyContent="center"
            alignItems="center"
            sx={{ height: "100%" }}
        >
            <ToastContainer />
            <Grid
                item
                xs={12}
                md={6}
                container
                spacing={2}
                component={fetcher.Form}
                method="post"
            >
                {/* Success alert */}
                {/* {fetcher.state === "idle" && fetcher.data === true && (
                    <Grid item xs={12}>
                        <Alert severity="success">Test sent!</Alert>
                    </Grid>
                )} */}

                {/* Error alert */}
                {/* {fetcher.state === "idle" && fetcher.data && fetcher.data.error && (
                    <Grid item xs={12}>
                        <Alert severity="error">{fetcher.data.error}</Alert>
                    </Grid>
                )} */}

                <input type="hidden" name="cm-id" value={campaign.cm_id} />

                <Grid item xs={12}>
                    <PhoneNumberInput name="phone_number" required />
                </Grid>

                <Grid item xs={12}>
                    <LoadingButton
                        type="submit"
                        loading={fetcher.state === "submitting"}
                        fullWidth
                        variant="contained"
                    >
                        Send Test
                    </LoadingButton>
                </Grid>
            </Grid>
        </Grid>
    );
};

export default SendTest;